import React from 'react';
import PropTypes from 'prop-types';

import CloseCirc from 'shared-vectors/icons/CloseCirc';
import { Icon } from 'shared-vectors';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import makeClassName from 'shared-utils/src/makeClassName';
import sleep from 'shared-utils/src/sleep';
import { getHumanFiltersV13 } from '@helpers/search/Search';

import { useCtxGlobal } from '@client/app/Container';

import ConfirmDialog from '@async-components/ConfirmDialog';

import './style.scss';

const ResetButton = ({
  locations,
  filters,
  reset,
  setResetDialog,

  coords, 
}) => {
  const { isMobile, isDesktop, filtersProps, model } = useCtxGlobal();

  const vWidth = filtersProps?.viewport?.width || 0;
  console.log();
  const locationsCount = locations.length;
  const filtersCount = getHumanFiltersV13(model?.queryFilters || {}).length;

  const openConfirmDialog = () => {
    sleep(300).then(() => trackGTMEvents({
      category: 'Interaction',
      action: 'RLS-ResetLastSearch',
    }, null, true));
    setResetDialog(
      <ConfirmDialog
        msg={{
          title: 'Inizia da capo',
          text: 'Vuoi cancellare tutte le voci della tua ricerca e iniziare da capo?',
        }}
        trackData={{
          close: null,
          confirm: {
            category: 'Interaction',
            action: 'RLS-ConfirmResetLastSearch',
          },
        }}
        onClose={() => setResetDialog(null)}
        action={reset}
      />,
    );
  };

  const dataCondition = (
    locationsCount > 0
    || filtersCount > 0
    || !!filters.nearby
  );

  if (dataCondition) {
    const cls = makeClassName([
      'hp_reset',
      !isMobile ? 'hp_reset--variant' : 'hp_reset--variant2',
      !coords.left && 'hp_reset--hid',
    ]);

    const btnCls = makeClassName([
      'hp_reset__btn',
      'tp-s--s',
      'tp-w--m',
      'c-txt--w',
      'is-clickable',
    ]);

    const cta = 'Inizia da capo';

    const usableCoords = {
      top: coords.top,
      left: vWidth && vWidth < 1024 ? coords.mobLeft : coords.left,
    };

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      openConfirmDialog();
    }
  };   

    return (
      <div className={cls}>
        <div role="button" aria-haspopup="dialog" className={btnCls} style={{ ...usableCoords }} onClick={openConfirmDialog} onKeyUp={onKeyPress} tabIndex={0} aria-label={cta}>
          {cta}
          <Icon aria-hidden="true" name={CloseCirc} className="ml--xs" />
        </div>
      </div>
    );
  }

  return null;
};

export default ResetButton;

ResetButton.propTypes = {
  locations: PropTypes.instanceOf(Array),
  filters: PropTypes.instanceOf(Object),
  reset: PropTypes.func,
  setResetDialog: PropTypes.func,
  coords: PropTypes.instanceOf(Object),
};

ResetButton.defaultProps = {
  locations: [],
  filters: {},
  reset: () => { },
  setResetDialog: () => { },
  coords: null,
};
